import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import map from 'lodash.map';
import size from 'lodash.size';
import InfiniteScroll from 'react-infinite-scroll-component';
import Betslip from './Betslip';
import * as Maps from '../../store/map';

class MyBets extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isActive: 'All',
            show: false,
            content: [],
            height: 400,
            take: 20,
        };
        this.selector = React.createRef();
    }

    setActiveTab = (tab) => {
        this.setState({
            isActive: tab,
        });
    };

    closeModal = () => {
        this.setState({
            show: false,
        });
    };

    closeModal = () => {
        this.setState({ show: false });
    };

    refCallback = (e) => {
        if (e) {
            this.parentElement = e;
        }
    };

    fetchMoreData = () => {
        var { take } = this.state;
        let { betslips } = this.props.user;

        this.props.getBetslips({
            take: take,
            skip: size(betslips),
        });
    };

    componentDidMount() {
        const rect = this.selector.current.getBoundingClientRect();
        this.setState({ height: rect.height });
        var { take } = this.state;
        this.props.setBetslips([]);
        this.props.getBetslips({
            take: take,
            skip: 0,
        });
    }

    render() {
        let { isActive, height } = this.state;
        let { betslips, lastPulledBetslipsCount } = this.props.user;

        let drawBetslips = betslips
            ? map(betslips, (betslip) => {
                  return <Betslip betslip={betslip} key={betslip.id} />;
              })
            : null;

        let betslipsCount = size(betslips);
        let haseMore = !(lastPulledBetslipsCount === 0 && betslipsCount > 0);

        return (
            <div className="main-container mybet" id="mybets" ref={this.selector}>
                <Row md="auto" className="mybet__result">
                    <Col xs="3" className={`py-3 ${isActive === 'All' ? 'active' : ''}`} onClick={(e) => this.setActiveTab('All')}>
                        All
                    </Col>
                    <Col xs="3" className={`py-3 px-0 ${isActive === 'in-game' ? 'active' : ''}`} onClick={(e) => this.setActiveTab('in-game')}>
                        In Game
                    </Col>
                    <Col xs="3" className={`py-3 ${isActive === 'won' ? 'active' : ''}`} onClick={(e) => this.setActiveTab('won')}>
                        Won
                    </Col>
                    <Col xs="3" className={`py-3 px-0 ${isActive === 'lost' ? 'active' : ''}`} onClick={(e) => this.setActiveTab('lost')}>
                        Lost
                    </Col>
                </Row>
                <Row md="auto" className="mx-auto text-center py-1 fs-12 bg-light-head">
                    <Col xs="2" className="py-2">
                        Date
                    </Col>
                    <Col xs="3" className="py-2 px-0">
                        Amount
                    </Col>
                    <Col xs="3" className="py-2 px-0">
                        Possible win
                    </Col>
                    <Col xs="4" className="py-2 px-0 text-left">
                        Win amount
                    </Col>
                </Row>

                <InfiniteScroll height={height} dataLength={size(betslips)} next={this.fetchMoreData} hasMore={haseMore} loader={<h4>Loading...</h4>}>
                    {drawBetslips}
                    <div className="pb-5"></div>
                </InfiniteScroll>
            </div>
        );
    }
}

export default compose(connect(Maps.mapUserStateToProps, Maps.mapUserDispatchToProps))(MyBets);
